import { render, staticRenderFns } from "./BaseImageThumbnail.vue?vue&type=template&id=a105d9a2&scoped=true&"
import script from "./BaseImageThumbnail.vue?vue&type=script&lang=js&"
export * from "./BaseImageThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./BaseImageThumbnail.vue?vue&type=style&index=0&id=a105d9a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a105d9a2",
  null
  
)

export default component.exports